<template>
  <div class="pay-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem><div class="bread">订单支付</div></shBreadItem>
    </shBread>
  </div>
  <div class="pay">
    <div class="pay-info" v-if="order">
      <span class="icon iconfont icon-queren2"></span>
      <div class="tip">
        <p>订单提交成功！请尽快完成支付。</p>
        <p v-if="order.result[0]?.countdown >= -1">
          支付还剩 <span>{{ timeText }}</span
          >, 超时后将取消订单
        </p>
        <p v-else>订单已经超时</p>
      </div>
      <div class="amount">
        <span>应付总额：</span>
        <span>&yen;{{ order.result[0]?.salePrice }}</span>
      </div>
    </div>
    <!-- 付款方式 -->
    <div class="pay-type">
      <p class="head">选择以下支付方式付款</p>
      <div class="item">
        <p>支付平台</p>
        <a class="btn alipay" @click="toAliPay" target="_blank"></a>
        <a class="btn wx" @click="towxPay"></a>
      </div>
      <div class="item">
        <p>支付方式</p>
        <a class="btn" href="javascript:;">招商银行</a>
        <a class="btn" href="javascript:;">工商银行</a>
        <a class="btn" href="javascript:;">建设银行</a>
        <a class="btn" href="javascript:;">农业银行</a>
        <a class="btn" href="javascript:;">交通银行</a>
      </div>
    </div>
  </div>
  <!-- 微信支付弹框 -->
  <div class="dialog">
    <el-dialog
      v-model="wxPayDialog"
      title="支付提示"
      width="500"
      :before-close="wxPayClose"
    >
      <div class="pay-code">
        <template v-for="item in wxCodePay" :key="item.index">
          <h3>
            {{ item.orderName }}
          </h3>
          <p>订单号:{{ item.orderID }}</p>
          <div class="code-img">
            <img :src="item.wxCode" alt="" />
          </div>
          <div class="wx">
            <img
              src="https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/c66f98cff8649bd5ba722c2e8067c6ca.jpg"
              alt=""
            />
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { useRoute, useRouter } from "vue-router";
import {
  findOrderDetail,
  findAliPay,
  findWxPay,
  queryWxpay,
} from "@/api/order";
import { ref, onBeforeUnmount, onUnmounted } from "vue";
import { usePayTime } from "@/hooks";
import { ElMessage } from "element-plus";
import { ElMessageBox } from "element-plus";
export default {
  components: {},
  setup() {
    // 根据地址栏ID发请求获取订单数据
    const route = useRoute();
    const router = useRouter();
    const order = ref(null);
    const wxCodePay = ref([]);

    const aliCodePay = ref("");
    //支付倒计时
    const count = ref(0);
    const wxPayDialog = ref(false);
    const Timer = ref("");

    findOrderDetail(route.query.orderID).then((data) => {
      try {
        order.value = data;
        // 后端提供 countdown 倒计时秒数
        if (data.code == 200 && data.result[0]?.countdown >= -1) {
          start(data.result[0]?.countdown);
        }
      } catch (error) {
        console.log(error);
      }
    });

    // 倒计时工具函数
    const { start, timeText } = usePayTime();

    const visibleDialog = ref(false);
    //跳转到支付宝支付
    //在这里请注意视频（leName），题库（testsName），图书（booksName）的name名称不同而获取不到相应的值
    const toAliPay = async () => {
      visibleDialog.value = true;
      findAliPay(route.query.orderID).then((data) => {
        if (data.code == 200) {
          window.open(data.result, "_blank");
        }

        //aliCodePay.value = data;
      });
      /* const result = await axios.post(
        `${baseURL}user/alipay`,
        {
          orderID: route.query.orderID,
        },
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      if (result.data.code == 200) {
        console.log(result);
        window.location.href = result.data.paymentUrl;
      }*/
      // 支付地址
      // const payUrl = '后台服务基准地址+支付页面地址+订单ID+回跳地址'
      /*  const redirect = encodeURIComponent(
        "http://localhost:8080//#/pay/callback"
      );
      const payUrl = `${baseURL}pay/aliPay?orderId=${route.query.orderID}&redirect=${redirect}`; */
    };
    //点击了微信支付
    const towxPay = async () => {
      findWxPay(route.query.orderID).then((data) => {
        wxCodePay.value = data;
      });
      Timer.value = setInterval(interPanmentWx, 2000);
      wxPayDialog.value = true;
    };

    //查询微信支付订单状态
    const interPanmentWx = () => {
      try {
        queryWxpay(route.query.orderID).then((res) => {
          if (res.code == 200) {
            ElMessage({
              message: res.msg,
              type: "success",
            });
            clearInterval(Timer.value);
            router.push("/user/mine");
          } else {
            ElMessage({
              message: res.msg,
              type: "error",
            });
          }
        });
      } catch (error) {
        console.log(error.message);
      }
    };
    const wxPayClose = () => {
      ElMessageBox.confirm("请问您确定要关闭支付嘛~？")
        .then(() => {
          clearInterval(Timer.value);
          router.push("/user/mine");
        })
        .catch((error) => {
          console.log(error);
        });
    };
    onUnmounted(() => {
      if (Timer.value) {
        clearInterval(Timer.value);
      }
    });
    return {
      order,
      timeText,
      visibleDialog,
      wxPayDialog,
      toAliPay,
      towxPay,
      wxCodePay,
      wxPayClose,
      aliCodePay,
    };
  },
};
</script>

<style lang="less" scoped>
.pay-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.pay {
  width: 1240px;
  margin: 0 auto;

  .pay-info {
    background: #fff;
    display: flex;
    align-items: center;
    height: 240px;
    padding: 0 80px;
    .icon {
      font-size: 80px;
      color: #1dc779;
    }
    .tip {
      padding-left: 10px;
      flex: 1;
      p {
        &:first-child {
          font-size: 20px;
          margin-bottom: 5px;
        }
        &:last-child {
          color: #999;
          font-size: 16px;
        }
      }
    }
    .amount {
      span {
        &:first-child {
          font-size: 16px;
          color: #999;
        }
        &:last-child {
          color: @priceColor;
          font-size: 20px;
        }
      }
    }
  }
  .pay-type {
    margin-top: 20px;
    background-color: #fff;
    padding-bottom: 70px;
    p {
      line-height: 70px;
      height: 70px;
      padding-left: 30px;
      font-size: 16px;
      &.head {
        border-bottom: 1px solid #f5f5f5;
      }
    }
    .btn {
      width: 150px;
      height: 50px;
      border: 1px solid #e4e4e4;
      text-align: center;
      line-height: 48px;
      margin-left: 30px;
      color: #666666;
      display: inline-block;
      &.active,
      &:hover {
        border-color: @shColor;
        cursor: pointer;
      }
      &.alipay {
        background: url(https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/7b6b02396368c9314528c0bbd85a2e06.png)
          no-repeat center / contain;
      }
      &.wx {
        background: url(https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/c66f98cff8649bd5ba722c2e8067c6ca.jpg)
          no-repeat center / contain;
      }
    }
  }
}
.dialog {
  .pay-code {
    h3 {
      margin-bottom: 15px;
    }
    p {
      text-align: center;
      margin-bottom: 15px;
    }
    .code-img {
      text-align: center;
      margin-bottom: 8px;
    }
    .wx {
      text-align: center;
    }
  }
}
</style>
